'use strict';

var GridToolbarRomSummaryTopRecapDirective = function GridToolbarRomSummaryTopRecapDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-rom-summary-top-recap.html'),
    controller: 'GridToolbarRomSummaryTopRecapController'
  };
};
GridToolbarRomSummaryTopRecapDirective.$inject = [];
module.exports = GridToolbarRomSummaryTopRecapDirective;